import type { CommercetoolsProduct } from '@ecomm/data-simplisafe-api'
import { addAtomDebugLabel } from '@ecomm/utils/addAtomDebugLabel'
import { selectProduct } from '@simplisafe/ss-ecomm-data/redux/select'
import * as O from 'fp-ts/lib/Option'
import { atom, useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import type { ContentfulProductTopic } from './productTopicSchema'

/**
 * Looks up a product in redux state by SKU.
 */
export const useProduct = (sku: string, reportError?: boolean) => {
  const product = useSelector(selectProduct(sku, reportError))
  return product
}
